<input type="text" 
    class="form-control text-right sgt-decimal"
    #inputDecimal
    [class.ng-invalid]="ngControl.invalid"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    (focus)="onFocus($event)"
    (focusout)="onFocusout($event)"
    (keyup)="onKeyup($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder">